import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydButton from '../../../../../commonDesign/Button'
import FlexRow from '../../../../../molecules/FlexRow'

const useStyles = makeStyles(theme => ({
  codeBlock: {
    position: 'relative',
    '& pre': {
      paddingTop: '36px'
    }
  },
  codeHeader: {
    position: 'absolute',
    top: '12px',
    left: '12px',
    right: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  codeLanguage: {
    fontSize: '12px',
    color: 'var(--color-neutral-400)',
    textTransform: 'uppercase'
  },
  proposalChip: {
    margin: '8px 0',
    padding: '6px 10px',
    backgroundColor: 'var(--surface-bg-color-d1)',
    borderRadius: '6px',
    fontSize: 'var(--font-size-xs)',
    color: 'var(--color-neutral-400)',
    display: 'inline-block',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--surface-bg-color-d2)'
    }
  }
}))

function CodeBlockWithActions ({ code, language, onApplyToEditor }) {
  const classes = useStyles()

  const isPipelineJson = useMemo(() => {
    if (language !== 'json') return false
    try {
      const parsed = JSON.parse(code)
      return Array.isArray(parsed) && parsed.length > 0
    } catch {
      return false
    }
  }, [code, language])

  if (isPipelineJson && onApplyToEditor) {
    return (
      <div
        className={classes.proposalChip}
        onClick={() => onApplyToEditor(code)}
      >
        📝 Pipeline proposal — see diff in editor →
      </div>
    )
  }

  return (
    <div className={classes.codeBlock}>
      <div className={classes.codeHeader}>
        <span className={classes.codeLanguage}>{language || 'text'}</span>
        <FlexRow gap='xs'>
          <SydButton
            size='xs'
            variant='ghost'
            onClick={() => navigator.clipboard.writeText(code)}
            icon='fileCopy'
          >
            Copy
          </SydButton>
        </FlexRow>
      </div>
      <pre style={{
        border: 'var(--border-neutral-thin)',
        backgroundColor: 'var(--surface-bg-color-d2)',
        padding: '12px',
        borderRadius: '8px',
        overflow: 'auto',
        margin: 0
      }}
      >
        <code style={{
          backgroundColor: 'transparent',
          padding: 0,
          fontFamily: 'var(--font-family-monospace)',
          fontSize: '13px'
        }}
        >
          {code}
        </code>
      </pre>
    </div>
  )
}

CodeBlockWithActions.propTypes = {
  code: PropTypes.string.isRequired,
  language: PropTypes.string,
  onApplyToEditor: PropTypes.func
}

export default CodeBlockWithActions
